import { ICircleStoreModel } from '@/editor/store/reducers/adSet-step.slice';

enum CircleRadius {
  META = 17000,
  DEFAULT = 3000,
  MAX = 80000,
}

class MapService {
  private map: google.maps.Map | null = null;
  private circleRegistry: Map<string, google.maps.Circle> = new Map();
  private maxRadius: number = CircleRadius.MAX;
  private minRadius: number = CircleRadius.META;

  setMinRadius(radius: CircleRadius) {
    this.minRadius = radius;
  }

  setMap(map: google.maps.Map | null) {
    this.map = map;
  }

  getMap() {
    return this.map;
  }

  createCircle(
    lat: number,
    lng: number,
    radius: number,
    address: string,
    options?: {
      onRadiusChange?: (radius: number) => void;
      onCenterChange?: (center: google.maps.LatLng) => void;
      panToCircle?: boolean;
    }
  ): google.maps.Circle | undefined {
    if (!this.map) {
      console.error('Map not initialized');
      return;
    }

    const circle = new google.maps.Circle({
      center: new google.maps.LatLng({ lat, lng }),
      radius,
      editable: true,
      draggable: true,
      map: this.map,
    });

    circle.addListener('radius_changed', () => {
      const newRadius = circle.getRadius();
      if (newRadius > this.maxRadius) circle.setRadius(this.maxRadius);
      if (newRadius < this.minRadius) circle.setRadius(this.minRadius);

      if (options?.onRadiusChange) {
        options.onRadiusChange(circle.getRadius());
      }
    });

    if (options?.onCenterChange) {
      circle.addListener('center_changed', function () {
        if (options.onCenterChange) {
          options.onCenterChange(circle.getCenter()!);
        }
      });
    }

    if (options?.panToCircle !== false) {
      this.map.panTo(circle.getCenter()!);
    }

    this.circleRegistry.set(address, circle);
    return circle;
  }

  restoreCirclesFromRegistry() {
    if (this.map) {
      this.circleRegistry.forEach((el) => {
        el.setMap(this.map);
      });
    }
  }

  addCirclesToMap(circles: ICircleStoreModel[]) {
    if (this.circleRegistry.size > 0) {
      this.restoreCirclesFromRegistry();
      return;
    }

    circles.forEach((el) => {
      this.createCircle(el.center.lat, el.center.lng, el.radius, el.address);
    });
  }

  removeCircle(address: string) {
    if (this.circleRegistry.size === 0) return;

    this.circleRegistry.get(address)?.setMap(null);
    this.circleRegistry.delete(address);
  }

  panToLocation(lat: number, lng: number) {
    if (this.map) {
      this.map.panTo(new google.maps.LatLng(lat, lng));
    }
  }

  changeDefaultRadius(isMetaActive: boolean, radius: number) {
    console.log(`isMetaActive in service: ${isMetaActive}`);

    isMetaActive ? this.setMinRadius(CircleRadius.META) : this.setMinRadius(CircleRadius.DEFAULT);

    this.circleRegistry.forEach((el) => {
      el.setRadius(radius);
    });
  }
}

export const mapService = new MapService();
